'use client'

import { Navigate } from '@/lib/router'

/** Public posts are not live yet; send deep links to the blog landing. */
export default function BlogPostPage() {
  return <Navigate to="/blog" replace />
}
